module.exports = __webpack_public_path__ + "img/VTBOSQUEDEMATASNOSCRIANZA.5ed5ca55.jpg";